<template>
  <div>
    <template v-if="$userIsGraduate && placementIsNotFinalised">
      <h3 class="mt-5">Editing your placement plan</h3>
      <p>Your Start of Placement Plan has been submitted for approval. Once approved this plan will be complete, ready for review at the end of placement.</p>
      <p>You may edit your plan; however, your manager will need to approve all changes.</p>
    </template>

    <div class="card">
      <ul class="list-data no-links no-hover">
        <li>
          <div class="row align-items-center">
            <div class="col">
              <p>Performance Objectives</p>
            </div>

            <div class="col-auto">
              <router-link :to="{ name: 'placements.single.start.manager.performance', params: { placementId: placement.id, graduateId: placement.graduate_id }}" v-if="$userIsManager || $userIsCoordinator" class="btn btn-sm btn-outline-dark">
                <font-awesome :icon="['fal', 'eye']" class="mr-2"/>
                View
              </router-link>
              <router-link :to="{ name: 'placements.single.start.performance', params: { placementId: placement.id } }" v-else-if="$userIsGraduate && placementIsNotFinalised" class="btn btn-sm btn-outline-dark">
                <font-awesome :icon="['fal', 'pencil']" class="mr-2"/>
                Edit
              </router-link>
            </div>
          </div>
        </li>

        <li>
          <div class="row align-items-center">
            <div class="col">
              <p>Development Objectives</p>
            </div>

            <div class="col-auto">
              <router-link :to="{ name: 'placements.single.start.manager.development', params: { placementId: placement.id, graduateId: placement.graduate_id }}" v-if="$userIsManager || $userIsCoordinator" class="btn btn-sm btn-outline-dark">
                <font-awesome :icon="['fal', 'eye']" class="mr-2"/>
                View
              </router-link>
              <router-link :to="{ name: 'placements.single.start.development', params: { placementId: placement.id } }" v-else-if="$userIsGraduate && placementIsNotFinalised" class="btn btn-sm btn-outline-dark">
                <font-awesome :icon="['fal', 'pencil']" class="mr-2"/>
                Edit
              </router-link>
            </div>
          </div>
        </li>
      </ul><!-- /.list-data -->
    </div><!-- /.card -->

    <template v-if="($userIsManager || $userIsCoordinator) && placementStartComponentIsPendingReview">
      <h3 class="mt-5">Manager Sign-Off</h3>

      <div class="alert alert-info">
        <div class="row">
          <div class="col d-flex align-items-center">Please select 'Approve' to sign off the graduate's Start of Placement Plan OR provide commentary below if any amendments are required.</div>
          <div class="col-auto">
            <ladda-button :click="handleApprovePlacement" class="btn btn-success btn-approve-placement-plan">Approve</ladda-button>
          </div>
        </div><!-- /.row -->
      </div><!-- /.alert -->
    </template>
    <template v-else-if="$userIsGraduate">
      <h3 class="mt-5">Status</h3>

      <div v-if="placementStartComponentIsPendingReview" class="alert alert-info">
        <strong>Pending Manager Approval.</strong>
      </div><!-- /.alert -->

      <div v-else-if="placementStartComponentIsSignedOff" class="alert alert-success">
        <strong>Plan Approved.</strong>
      </div><!-- /.alert -->
    </template>

    <placements-start-component-review-comments></placements-start-component-review-comments>
  </div><!-- /.container-fluid -->
</template>

<script>
import { helpers, approvePlacementHelpers } from 'mixins/placements'
import PlacementsStartComponentReviewComments from './PlacementsStartComponentReviewComments'

export default {
  components: {
    PlacementsStartComponentReviewComments
  },

  mixins: [helpers, approvePlacementHelpers]
}
</script>
